import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('MultipleSessionSsoApp => ');

const onLoginNewUserRequest = createAction('send new user login request');
const onLoginNewUserSuccess = createAction('send new user login request success');
const onLoginNewUserFailure = createAction('send new user login request failure');

const onLoginCurrentRequest = createAction('send current user login request');
const onLoginCurrentSuccess = createAction('send current user login success');
const onLoginCurrentFailure = createAction('send current user login failure');

export default {
  onLoginNewUserRequest,
  onLoginNewUserSuccess,
  onLoginNewUserFailure,

  onLoginCurrentRequest,
  onLoginCurrentSuccess,
  onLoginCurrentFailure,
};
